<template>
    <div class="col-6">
        <div class="card">
            <div class="card-body">
                <div class="dropdown float-right">
                    <a href="#" class="dropdown-toggle card-drop" data-toggle="dropdown">
                        <i class="fas fa-ellipsis-v"/>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                        <li>
                            <a href="" @click.prevent="showCarrierDestinationModal()" class="dropdown-item">
                                <i class="fa fa-edit"/>
                                {{ $t("CarrierDestinationInfoCard.edit") }}
                            </a>
                        </li>
                    </ul>
                </div>
                <h4 class="header-title m-t-0">
                    <i class="fa fa-flag mr-1"></i>
                    {{ $t("CarrierDestinationInfoCard.carrierInfo") }}
                </h4>
                <hr/>
                <p><b>{{ $t("CarrierDestinationInfoCard.country") }}</b>: {{ carrierDestination.country.name }}  <img :src="getDiceBaseUrl() + carrierDestination.country.flagURL" width="20" class="shadow-sm"/></p>
                <p>
                    <b>{{ $t("CarrierDestinationInfoCard.area") }}</b>:
                    <router-link class="font-bold" :to="`/billing/carrier-area/${carrierDestination.area.id}`" v-if="carrierDestination.carrierAreaId">
                        {{ carrierDestination.area.name }}
                    </router-link>
                    <span v-else>
                        {{ $t("CarrierDestinationInfoCard.noArea") }}
                    </span>
                </p>
                <p><b v-html="$t('CarrierDestinationInfoCard.margin')"/>: <span v-html="carrierDestination.marginLabel()"/></p>
                <p><b>{{ $t("CarrierDestinationInfoCard.minDeliveryDays") }}</b>: <span v-html="carrierDestination.minDeliveryDaysLabel()"></span></p>
                <p><b>{{ $t("CarrierDestinationInfoCard.maxDeliveryDays") }}</b>: <span v-html="carrierDestination.maxDeliveryDaysLabel()"></span></p>
                <p><b>{{ $t("CarrierDestinationInfoCard.fixedTaxPercent") }}</b>: <span v-html="carrierDestination.fixedTaxPercentLabel()"></span></p>
            </div>
        </div>
        <CarrierDestinationFormModal @editCarrierDestination="editCarrierDestination" ref="CarrierDestinationFormModal"
                                     :carrier="carrier" :countries="countries"/>
    </div>
</template>

<script>
import CarrierDestinationFormModal from "../../../shared/Billing/CarrierDestination/CarrierDestinationFormModal";
export default {
    name: "CarrierDestinationInfoCard",
    components: {CarrierDestinationFormModal},
    props: {
        carrierDestination: {
            type: Object,
            required: true,
        },
        carrier: {
            type: Object,
            required: true,
        },
        countries: {
            required: true,
        },
    },
    methods: {
        showCarrierDestinationModal() {
            this.$refs.CarrierDestinationFormModal.show(this.carrierDestination);
        },
        editCarrierDestination(carrierDestination) {
            this.$emit("editCarrierDestination", carrierDestination);
        },
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>